import React from "react";
import axios from 'axios'
import { localStorageKey } from '../constants/LocalStorageKey';
import { AuthContext } from "../context/AuthProvider";
import constant from "../constants/Constatnt";

const apiKit = axios.create({
    baseURL: constant.baseUrl 
})
const WithAxios = ({ children }) => {
    const { loadingState, showNotification, signOut } = React.useContext(AuthContext)
    React.useMemo(() => {
        apiKit.interceptors.request.use((config) => {
            if(!JSON.parse(localStorage.getItem(localStorageKey.ISDEVTOOLOPEN))){
                loadingState(true);
                const token = localStorage.getItem(localStorageKey.APITOKEN);
                if (token) {
                    config.headers['Authorization'] = 'Bearer ' + token
                }
                // config.headers['Content-Type'] = 'application/json';
                return config
            }
            
        })
        apiKit.interceptors.response.use((response) => {
            loadingState(false);
            // if(response){

            // }
            // if (response.data.errors) {
            //     if (response.data.data.login === null) {
            //         //   showMessage({
            //         //     message: response.data.errors[0].message,
            //         //     type: "warning",
            //         //     icon: "warning",
            //         //   });
            //     } else if ((response.data.data.contract === null ||
            //         response.data.data.customerInfo === null ||
            //         response.data.data.validateSim === null ||
            //         response.data.data.createCustomer === null ||
            //         response.data.data.getProductOffers === null) && response.data.errors[0].code !== 401) {
            //         //   showMessage({
            //         //     message: response.data.errors[0].message,
            //         //     type: "info",
            //         //     icon: "info",
            //         //   });
            //     } else if (response.data.errors[0].code === 401) {
            //         //   showMessage({
            //         //     message: "You have been logged out!",
            //         //     type: "info",
            //         //     icon: "info",
            //         //   });
            //         //   navigate('Logout');        
            //     }
            // }
            return response;
        }, (error) => {
            if(!JSON.parse(localStorage.getItem(localStorageKey.ISDEVTOOLOPEN))){
            loadingState(false);
            showNotification(true, !!error?.response?.data?.message ? error.response.data.message : error.message);
            if (error.response.status === 429 || error.response.status === 401) {
                signOut();
            }
            return Promise.reject(error)
            }else{
                showNotification(true, "Devtools open, Close it and refresh the page!");
            }
            
        })
    }, [loadingState, showNotification, signOut])

    return children
}
export { WithAxios }
export default apiKit;